import Entity from "../templates/entity.js";
import setChiclet from "../helpers/chiclet.js";
import createId from "../helpers/generateId.js";

const contentTypes = instantsearch.connectors.connectRefinementList(
	(
		{ widgetParams, canRefine, items, createURL, refine, helper,
		searchForItems, isFromSearch },
		isFirstRender
	) => {
		if (  brookingsAlgoliaFeedOptions.facets.length && ! brookingsAlgoliaFeedOptions.facets.includes('article_type') ) {
			return;
		}

		const container = document.getElementById('typeFacets');

		if (isFirstRender) {
			document.querySelector('#typeFacets').classList.add('active');

			container.addEventListener("click", ({ target }) => {
				const input = target.closest(
					'input[type="checkbox"]'
				);

				if (input) {
					refine(input.value);
				}
			});

			container.addEventListener("input", ({ target }) => {
				const isSearchInput =
					target.nodeName === "INPUT" &&
					target.type === "search";

				if (isSearchInput) {
					searchForItems(target.value);
				}
			});

		} else {
			if ( items.length > 0 ) {
				items.forEach( (item) => {
					setChiclet(item,widgetParams.attribute,refine);
				});
			}
		}

		const tmTerms = JSON.parse(brookingsAlgolia.content_types);

		const orderdTerms = {};

		// add parent items
		tmTerms.forEach( (term) => {
			// check if items contains on object with the term.title value
			const found = items.find( (item) => {
				item.id = createId( item.label );
				return item.label === term.name;
			});
			
			if ( found && term.parent == '' ) {
				orderdTerms[term.name] = found;
			}
		});

		// add child items
		tmTerms.forEach( (term) => {
			const found = items.find( (item) => {
				return item.label === term.name;
			});
			if ( found && term.parent != '' ) {
				if ( ! orderdTerms[term.parent].children ) {
					orderdTerms[term.parent].children = [];
				}
				orderdTerms[term.parent].children.push(found);
			}
		});

		container.innerHTML =
			Object.values(orderdTerms).map(
				({
					value,
					id,
					isRefined,
					label,
					highlighted,
					count,
					children,
				}) => Entity({
					value,
					id,
					isRefined,
					label,
					highlighted,
					count,
					children,
					'type' : 'content_type'
				})
			)
			.join("");
	}
);

export default contentTypes